import BatteryCellsScore from './BatteryCellsScore';

export default BatteryCellsScore;
